import sdl from '@jds/react-generated-sdl/JDSMegaMenuItem';
import type { JDSMegaMenuItemProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSMegaMenuItemProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const { custom = '', ...rest } = props as any;
  return createComponent(
    json,
    rest,
    'JDSMegaMenuItem',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const MegaMenuItem = withLogic(Component) as React.FC<JDSMegaMenuItemProps> & {
  slotName?: string;
};

MegaMenuItem.displayName = 'MegaMenuItem';
MegaMenuItem.slotName = 'jds_mega_menu_item';

export { MegaMenuItem, type JDSMegaMenuItemProps };
